<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__semi-reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-review-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>
    <div *ngIf="loading" class="table__no-items">Loading review details...</div>

    <ng-container *ngIf="!loading && ruleSetData">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-slide-toggle
          [checked]="ruleSetData.active"
          (click)="$event.stopPropagation()"
          (change)="activateOrDeactivateRule($event)"></mat-slide-toggle>

        <h2 fxFlex class="nomargin input__editable">
          <input
            #nameInput
            class="input__borderless"
            type="text"
            [style.width.px]="nameInput.value.length * 13"
            [(ngModel)]="ruleSetData.name"
            (change)="updateRuleSet()" />
        </h2>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <div class="rule__section-container">
        <h3 fxLayoutAlign="start center" fxLayoutGap="12px" class="not-clickable">
          <sbnb-icon icon="message" class="text-smoke-darker"></sbnb-icon>
          <span>Review</span>
          <span class="card__collapsed-helper-text">This text will be sent as the review.</span>
        </h3>

        <div>
          <sbnb-rule-editor
            #ruleEditor
            [ruleSetId]="ruleSetId"
            [ruleType]="ruleSetData.event"
            [importEnabled]="true"
            (saveStatusChange)="ruleSaveStatusChange($event)"></sbnb-rule-editor>
        </div>
      </div>

      <div class="rule__section-container" *ngIf="ratingsEnabled">
        <h3 fxLayoutAlign="start center" fxLayoutGap="12px" class="not-clickable">
          <sbnb-icon icon="star" class="text-smoke-darker"></sbnb-icon>
          <span>Default Ratings</span>
          <span class="card__collapsed-helper-text">Set default ratings and tags for this review template.</span>
        </h3>

        <div class="flex flex-col gap-6">
          <div class="flex gap-4">
            <div class="w-0.5 bg-gradient-to-b from-smoke/50 via-smoke/40 to-transparent rounded-full"></div>
            <div class="flex-1 flex flex-col gap-2">
              <div class="text-base font-medium text-night">Cleanliness</div>
              <div class="flex flex-col gap-2">
                <sbnb-stars
                  [startingCount]="ruleSetData.grades?.cleanliness || 5"
                  (updated)="updateGrades('cleanliness', $event)">
                </sbnb-stars>
                <sbnb-review-tags
                  *ngIf="tagsEnabled"
                  category="cleanliness"
                  [selectedTags]="getSelectedTags('cleanliness')"
                  (tagsChange)="updateTags('cleanliness', $event)"
                  data-test="cleanliness-tags">
                </sbnb-review-tags>
              </div>
            </div>
          </div>

          <div class="flex gap-4">
            <div class="w-0.5 bg-gradient-to-b from-smoke/50 via-smoke/40 to-transparent rounded-full"></div>
            <div class="flex-1 flex flex-col gap-2">
              <div class="text-base font-medium text-night">Communication</div>
              <div class="flex flex-col gap-2">
                <sbnb-stars
                  [startingCount]="ruleSetData.grades?.communication || 5"
                  (updated)="updateGrades('communication', $event)">
                </sbnb-stars>
                <sbnb-review-tags
                  *ngIf="tagsEnabled"
                  category="communication"
                  [selectedTags]="getSelectedTags('communication')"
                  (tagsChange)="updateTags('communication', $event)"
                  data-test="communication-tags">
                </sbnb-review-tags>
              </div>
            </div>
          </div>

          <div class="flex gap-4">
            <div class="w-0.5 bg-gradient-to-b from-smoke/50 via-smoke/40 to-transparent rounded-full"></div>
            <div class="flex-1 flex flex-col gap-2">
              <div class="text-base font-medium text-night">Respect of house rules</div>
              <div class="flex flex-col gap-2">
                <sbnb-stars
                  [startingCount]="ruleSetData.grades?.respect_house_rules || 5"
                  (updated)="updateGrades('respect_house_rules', $event)">
                </sbnb-stars>
                <sbnb-review-tags
                  *ngIf="tagsEnabled"
                  category="respect_house_rules"
                  [selectedTags]="getSelectedTags('respect_house_rules')"
                  (tagsChange)="updateTags('respect_house_rules', $event)"
                  data-test="house-rules-tags">
                </sbnb-review-tags>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rule__section-container rule__section-collapsed">
        <div fxLayout fxLayoutAlign="start center">
          <h3
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px"
            class="not-clickable">
            <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>Timing</span>
          </h3>
          <sbnb-rule-timing
            *ngIf="timingsMeta && ruleSetData"
            [meta]="timingsMeta"
            [ruleset]="ruleSetData"
            (triggerSave)="timingUpdated($event)"></sbnb-rule-timing>
        </div>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-icon icon="scope" class="text-smoke-darker"></sbnb-icon>
            <span>Scope</span>
            <span class="card__collapsed-helper-text">Limit the usage of this review with the options below.</span>
          </h3>
        </div>

        <div>
          <sbnb-rule-scope
            [airbnbOnly]="true"
            [initial]="ruleSetData"
            (completed)="handleScopeChange($event)"></sbnb-rule-scope>
        </div>
      </div>

      <div class="rule__section-container" fxLayout>
        <div fxFlex fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
          <sbnb-button
            label="Delete"
            icon="delete"
            type="text"
            [labelColor]="'#ED3C6A'"
            (clicked)="deleteRulesetPrompt()"></sbnb-button>

          <sbnb-button
            label="Copy"
            icon="copy"
            type="text"
            [labelColor]="'#ED3C6A'"
            (clicked)="copyRuleset()"></sbnb-button>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
